import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Animations } from '../../animations';
import { FocusService } from 'app/focus.service';

@Component({
  selector: 'fts-sms-offer-description',
  templateUrl: './sms-offer-description.component.html',
  styleUrls: ['./sms-offer-description.component.scss'],
  animations: [Animations.expanded],
})
export class SmsOfferDescriptionComponent {
  @Input()
  public description: string;

  public collapsed = true;

  constructor(public translateService: TranslateService, private focusService: FocusService) {}

  onAnimationDone() {
    if (!this.collapsed) {
      this.focusService.applyFocus('sms-modal-offer-description');
    }
  }
}
